import { X } from 'lucide-react';
import React from 'react';

const Modal = ({ children, onClose }) => {
  return (
    <div className="fixed inset-0 bg-[rgba(0,0,0,0.4)] bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-4 relative">
        <button 
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 cursor-pointer"
        >
          <X />
        </button>
        {children}
      </div>
    </div>
  );
};

export default Modal;